<template>
  <b-table
    responsive
    :fields="columns"
    :items="tableData"
    caption-top
  >
    <template #table-caption>
      <span class="text-primary">{{ caption }}</span>
    </template>
  </b-table>
</template>

<script>
import { BTable } from 'bootstrap-vue'

export default {
  components: { BTable },

  props: {
    data: {
      type: Object,
      required: true,
    },
    caption: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const columns = ['zone', 'count']
    const tableData = props.data.aggregations.config.buckets.map(el => ({
      zone: el.key.split('::')[1],
      count: el.doc_count,
    }))

    return {
      columns,
      tableData,
    }
  },
}
</script>

<style>

</style>
